import styled from 'react-emotion';
import CommonBackButton from '../../common/BackButton/BackButton';

export const StyledButton = styled(CommonBackButton)`
  padding: 20px 0 0 48px;
`;

export default StyledButton;
